var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"servigua"}},[_c('div',{staticClass:"container row z-depth-4 animated zoomIn",attrs:{"transition":"zoomIn"}},[_c('div',{staticClass:"col s12 l12 center"},[_c('img',{staticClass:"responsive-img",attrs:{"src":require("@/assets/imagenes/servigua.jpg"),"width":"900","height":"550"}})])])])
}]

export { render, staticRenderFns }